export const formatCOP = (n: number): string => {
  return "$" + n.toLocaleString("es-CO");
};

export const colorFromName = (name: string): string => {
  const palette = [
    "#4012AB",
    "#16A34A",
    "#0EA5E9",
    "#DC2626",
    "#EAB308",
    "#9333EA",
    "#0891B2",
    "#D946EF",
  ];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % palette.length;
  return palette[h];
};

export const initials = (name: string): string => {
  // A phoneless lead is titled `@handle` (see lib/contact.ts), and the bare "@" is
  // not a useful avatar — drop it so the first letter of the handle shows instead.
  return name
    .replace(/^@/, "")
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
};
